import { useEffect } from "react";

import { useActivationProjectContext } from "app/pages/activation/context/Project/ProjectContext";
import { useIconsQuery } from "app/pages/activation/queries/useIconsQuery";

export const useRTDomainIcon = (domain: string): string => {
    const { favicons, onFaviconsSet } = useActivationProjectContext();
    const domainImageUrl = favicons[domain] || "";

    const { data: fetchedFavicons, isLoading: isIconsLoad } = useIconsQuery([domain], !domainImageUrl);

    useEffect(() => {
        if (fetchedFavicons && !isIconsLoad) {
            onFaviconsSet(fetchedFavicons);
        }
    }, [isIconsLoad]);

    return domainImageUrl;
};
